(function ($) {
    $.fn.PhoneMask = function (options, clickTrack) {
        var defaults = { collapseCss: 'phone', expandCss: 'phone-expanded', dataMemberName: 'number', dataDepartmentName: "department", isMobile: false };

        var settings = $.extend(defaults, options);

        return this.each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                var $ctl = $(this);
                $ctl.find('a').fadeOut(function () {

                    var phoneNo = $ctl.attr('data-' + settings.dataMemberName);
                    var placeHolder = $ctl.removeClass(settings.collapseCss)
                        .addClass(settings.expandCss);

                    if (settings.isMobile) {
                        placeHolder.html('<a class="tel" href="tel:' + phoneNo + '">' + phoneNo + '</a>');
                    } else {
                        placeHolder.html(phoneNo);
                    };                        
                });

                if (typeof clickTrack === "function") {
                    clickTrack($ctl.attr('data-' + settings.dataDepartmentName));
                }

                $ctl.unbind('click');
            });
        });
    };
})(jQuery);